import { axios, axios2 } from '@/lib/axios';
import { ApiResponse } from '@/types';

export type AddData = {
  first_name: string;
  last_name: string;
  gender: string;
  dob: string;
  email: string;
  message: string;
  property_id: string;
  property_type: string;
  customer_id: string;
  project_id:string;
  name:string;
  company_name:string;
  telephone:string;
};
export const AddForm = (data: AddData): Promise<ApiResponse<{ message: string }>> => {
  // return axios2.post('/customer-api/fill-buy-property-form', data);
  return axios2.post('/customer-api/inquire-property-project', data);
};
